// string begins with 1+ characters other than "/", has a "/", and is followed by one character other than "/"
// OR string begins with "/", is followed by 1 character other than "/", ends with any # of any character
// while ignoring capitalization
const relativeUrlMatch = new RegExp(`^[^\/]+\/[^\/].*$|^\/[^\/].*$`, 'i');

const isSpaceSidebarLink = (node) => {
	return node?.['__typename'] === 'SpaceSidebarLink';
};

// This function takes in a SpaceNavigationQuery response and returns an array of SmartLink resourceUrls
export const getSmartShortcuts = (res: any): Array<{ appearance: string; resourceUrl: string }> => {
	const content = res?.data?.spaceSidebarLinks?.quick ?? [];
	return content.filter(isSpaceSidebarLink).map((node) => {
		return {
			appearance: 'inline',
			// adding domain to relative confluence URLs so smart links don't error
			resourceUrl: relativeUrlMatch.test(node?.url)
				? window.location.origin + node?.url
				: node?.url,
		};
	});
};
